import { translate } from '../../../common/helpers/translate.helper';

export const getLubesDetailBreadcrumbLabel = (
    pathname: string | undefined,
    isSuperAdmin: boolean,
    fallbackLabel: string
) => {
    switch (pathname) {
        case '/dashboard':
            return translate('navigation.dashboard');
        case '/search':
            return translate('page.searchresultview');
        case '/requests-for-quotes':
            return translate('navigation.requestsForQuotes');
        case '/orders':
            return translate('navigation.orders');
        case '/offers':
            return translate(isSuperAdmin ? 'navigation.offers' : 'navigation.orders');
        default:
            return fallbackLabel;
    }
};
